import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCCIPFApVaGX6vd_-3AxNYKcp12C2Y-5Uo",
  authDomain: "babs-2ee3f.firebaseapp.com",
  projectId: "babs-2ee3f",
  storageBucket: "babs-2ee3f.firebasestorage.app",
  messagingSenderId: "152946846254",
  appId: "1:152946846254:web:e2b68814dc85b94a91b6bf",
  measurementId: "G-3YGRXVESTT"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);